export default __webpack_public_path__ + "static/media/regulatory--keep-left--g5.83797d4a.png";